import { http } from "./http";

export const AuthService = {
  async loginSendOtp({ email, password }) {
    return http("/api/auth/login", {
      method: "POST",
      body: { email, password },
    });
  },

  async verifyOtp({ email, otp }) {
    return http("/api/auth/verify-otp", {
      method: "POST",
      body: { email, otp },
    });
  },

  async me() {
    return http("/api/auth/me", { method: "GET" });
  },

  async logout() {
    return http("/api/auth/logout", { method: "POST" });
  },

  async switchContext({ dashboard, warehouseId = null }) {
    return http("/api/auth/switch-context", {
      method: "POST",
      body: { dashboard, warehouseId },
    });
  },

  async forgotSendOtp({ email }) {
    return http("/api/auth/forgot-password/send-otp", {
      method: "POST",
      body: { email },
    });
  },

  async forgotCheckOtp({ email, otp }) {
  return http("/api/auth/forgot-password/check-otp", {
    method: "POST",
    body: { email, otp },
  });
},

  async forgotVerifyAndSetPassword({
    email,
    otp,
    newPassword,
    confirmPassword,
  }) {
    return http("/api/auth/forgot-password/verify-otp", {
      method: "POST",
      body: { email, otp, newPassword, confirmPassword },
    });
  },

  async changePasswordSendOtp({
    currentPassword,
    newPassword,
    confirmPassword,
  }) {
    return http("/api/auth/change-password/send-otp", {
      method: "POST",
      body: { currentPassword, newPassword, confirmPassword },
    });
  },

  async changePasswordVerifyOtp({ otp }) {
    return http("/api/auth/change-password/verify-otp", {
      method: "POST",
      body: { otp },
    });
  },

  async changeTemporaryPassword({ newPassword, confirmPassword }) {
    return http("/api/auth/change-temporary-password", {
      method: "POST",
      body: { newPassword, confirmPassword },
    });
  },

  async updateOnboarding(payload) {
    return http("/api/auth/onboarding", {
      method: "PATCH",
      body: payload,
    });
  },

  async createOrUpdateOnboarding(payload) {
    return http("/api/auth/onboarding", {
      method: "POST",
      body: payload,
    });
  },
};

